// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page_wrapper__vZV5S","main":"page_main__t6eO0","is_initial":"page_is_initial__QEkhC","is_noFlex":"page_is_noFlex__Kr62q"};